(function () {
  var btn = document.querySelector('.hb-hero__scroll');
  var hero = document.querySelector('.hb-hero');
  if (!btn || !hero) return;

  btn.addEventListener('click', function () {
    var header = document.getElementById('hb-header');
    var headerHeight = header ? header.offsetHeight : 0;
    var target = hero.getBoundingClientRect().bottom + window.scrollY - headerHeight;
    window.scrollTo({ top: target, behavior: 'smooth' });
  });
})();